(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-studio-partner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousel = (root) => {
      if (!root || root.dataset.carouselReady === 'true') return;

      const viewport = root.querySelector('.ip-studio-partner__carousel');
      const track = root.querySelector('.ip-studio-partner__track');
      if (!viewport || !track) return;

    const originals = Array.from(track.children);
    const count = originals.length;
    if (!count) return;
    root.dataset.carouselReady = 'true';

    const makeClones = () => originals.map((slide) => {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      return clone;
    });

    track.replaceChildren(...makeClones(), ...originals, ...makeClones());

    const slides = Array.from(track.children);
    const gap = Number.parseFloat(getComputedStyle(root).getPropertyValue('--ipsp-gap')) || 8;
    const transitionSpeed = Number(viewport.dataset.transitionSpeed) || 500;
    const autoplaySpeed = Number(viewport.dataset.autoplaySpeed) || 5000;
    const autoplayEnabled = viewport.dataset.autoplay === 'true';
    const pauseOnHover = viewport.dataset.pauseHover === 'true';
    const pauseOnInteraction = viewport.dataset.pauseInteraction === 'true';

    let index = count;
    let step = 0;
    let timer = null;
    let dragging = false;
    let moved = false;
    let interactionPaused = false;
    let startX = 0;
    let startTranslate = 0;
    let currentTranslate = 0;

    const slidesPerView = () => {
      if (window.innerWidth <= 749) return Math.max(1, Number(viewport.dataset.mobileSlides) || 2);
      if (window.innerWidth <= 989) return Math.max(1, Number(viewport.dataset.tabletSlides) || 2);
      return Math.max(1, Number(viewport.dataset.desktopSlides) || 4);
    };

    const setTranslate = (value, animate = true) => {
      currentTranslate = value;
      track.style.transition = animate ? `transform ${transitionSpeed}ms ease` : 'none';
      track.style.transform = `translate3d(${value}px, 0, 0)`;
    };

    const layout = () => {
      const perView = Math.min(slidesPerView(), count);
      const slideWidth = (viewport.clientWidth - gap * (perView - 1)) / perView;
      step = slideWidth + gap;
      slides.forEach((slide) => {
        slide.style.width = `${slideWidth}px`;
      });
      setTranslate(-(index * step), false);
    };

    const moveTo = (nextIndex, animate = true) => {
      index = nextIndex;
      setTranslate(-(index * step), animate);
    };

    const stopAutoplay = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (autoplayEnabled && count > slidesPerView()) {
        timer = window.setInterval(() => moveTo(index + 1), autoplaySpeed);
      }
    };

    track.addEventListener('transitionend', (event) => {
      if (event.propertyName !== 'transform') return;
      if (index >= count * 2) {
        index -= count;
        setTranslate(-(index * step), false);
      } else if (index < count) {
        index += count;
        setTranslate(-(index * step), false);
      }
    });

    viewport.addEventListener('pointerdown', (event) => {
      if (event.button !== undefined && event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startTranslate = currentTranslate;
      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
      viewport.setPointerCapture?.(event.pointerId);
      if (pauseOnInteraction) interactionPaused = true;
      stopAutoplay();
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      currentTranslate = startTranslate + delta;
      track.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
    });

    const finishDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      const delta = event.clientX - startX;
      const threshold = Math.min(step * 0.2, 80);
      if (Math.abs(delta) > threshold) moveTo(index + (delta < 0 ? 1 : -1));
      else moveTo(index);
      if (!pauseOnInteraction) startAutoplay();
    };

    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);
    viewport.addEventListener('dragstart', (event) => event.preventDefault());
    viewport.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    if (pauseOnHover) {
      viewport.addEventListener('mouseenter', stopAutoplay);
      viewport.addEventListener('mouseleave', () => {
        if (!dragging && !interactionPaused) startAutoplay();
      });
    }

    let resizeFrame = null;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(layout);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else if (!interactionPaused) startAutoplay();
    });

    document.addEventListener('shopify:block:select', (event) => {
      if (!root.contains(event.target)) return;
      stopAutoplay();
      const selectedIndex = originals.indexOf(event.target);
      if (selectedIndex >= 0) moveTo(count + selectedIndex);
    });

      layout();
      startAutoplay();
    };

    document.querySelectorAll('.ip-studio-partner').forEach(initCarousel);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.ip-studio-partner').forEach(initCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
